import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, imageURL, baseURLV1 } from "../../../service/API.js";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import CropperImage from "../CropperImage";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
// import { temp_store } from "../../../modules/function/temp_store"
import ImageResize from "image-resize";
import Resizer from "react-image-file-resizer";

export const EditProductManagement = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  suhbeader.setTitle('Edit ProductManagement');
  const history = useHistory();

  const [item_image_path, setItem_image_path] = useState();
  const [nameImageItem_image_path, setNameImageItem_image_path] = useState("");



  const [name, setName] = useState();
  const [code, setCode] = useState();
  const [image_path, setImage_path] = useState();
  const [class_id, setClass_id] = useState();
  const [is_active, setIs_active] = useState();
  const [machine_id, setMachine_id] = useState();

  const [listclass, setListclass] = useState();
  const [listmachine, setListmachine] = useState();

  const [displayOrder, setDisplayOrder] = useState(0)



  const [stateItem_image_path, setStateItem_image_path] = useState({
    previewItem_image_path: null,
    rawItem_image_path: null,
    imageURLItem_image_path: null,
  });

  const AlertError = (message) => {
    Swal.fire("Menu Management!", message, "error");
  };


  useEffect(() => {
    setName(props.location.state.row.name);
    setCode(props.location.state.row.code);
    setItem_image_path(props.location.state.row.image_path);
    setClass_id(props.location.state.row.class_id);
    props.location.state.row.is_active ? setIs_active('1') : setIs_active('0');
    setMachine_id(props.location.state.row.machine_id);
    setDisplayOrder(props.location.state.row.ordering)
    getListClass()
    getListMachine()
  }, []);
  const imageResize = new ImageResize({
    format: "png", // ไฟล์รูปภาพเป็น png
    quality: 0.5, // ปรับขนาดไฟล์รูปภาพให้เหลือครึ่งนึง
    width: 500, // ปรับขนาดรูปให้มีความกว้าง 500 px
  });
  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  const handleChangeMachine = (event) => {
    setMachine_id(event.target.value);
  };
  const handleChangeClass = (event) => {
    console.log(event.target.value)
    setClass_id(event.target.value);
  };
  const handleChangeItem_image_path = async (e) => {
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();
      e.target.value = '';
      handleImageUploadItem_image_path(file)
    }
  };
  const getListClass = async (page, limit) => {
    const apiUrls = `${baseURLV1}/class?page=1&limit=10000&active=1`;
    let token = localStorage.getItem("Token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        setListclass(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getListMachine = async (page, limit) => {
    const apiUrls = `${baseURLV1}/machine?page=1&limit=10000`;
    let token = localStorage.getItem("Token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        setListmachine(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                3000,
                "PNG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        });

  const handleImageUploadItem_image_path = async (file) => {
    const image = await resizeFile(file);
    imageResize
      .play(URL.createObjectURL(file))
      .then(async function (response) {
        const trans = dataURLtoFile(image, 'img.png')
        var formdata = new FormData();
        let token = localStorage.getItem("Token");
        formdata.append("image", trans, URL.createObjectURL(trans));

        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
        fetch(`${baseURLV1}/upload`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            let res = JSON.parse(result);
            setStateItem_image_path({
              previewItem_image_path: null,
              rawItem_image_path: null,
              imageURLItem_image_path: null,
            });
            let fullPath = `${baseURL}/uploads/${res.filename}`
            setItem_image_path(fullPath);
            setNameImageItem_image_path(fullPath);
          })
          .catch((error) => console.log("error", error));
      })

  };

  const removeImageItem_image_path = async () => {
    setStateItem_image_path({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
    setItem_image_path("");
  };

  const handleCancelUploadItem_image_path = () => {
    setStateItem_image_path({
      previewItem_image_path: null,
      rawItem_image_path: null,
      imageURLItem_image_path: null,
    });
  };

  const getImg = () => {
    if (item_image_path) {
      return {
        img: item_image_path
      }
    } else {
      return {}
    }
  }

  const onSubmit = async () => {
    let img = {}
    if (name === undefined || name === "") {
      return AlertError("please insert name");
    }
    // if (code === undefined || code === "") {
    //   return AlertError("please insert code");
    // }
    if (class_id === undefined || class_id === "") {
      return AlertError("please insert class_id");
    }
    if (machine_id === undefined || machine_id === "") {
      return AlertError("please insert machine_id");
    }
    if (is_active === undefined || is_active === "") {
      return AlertError("please insert item name en2.");
    }
    if (nameImageItem_image_path === undefined) {
      return AlertError("please insert image");
    } else {
      if (nameImageItem_image_path !== "") img = {
        image: nameImageItem_image_path,
      }
    }

    var events = {
      name: name,
      code: code,
      image_path: item_image_path,
      class_id: String(class_id),
      is_active: is_active,
      machine_id: String(machine_id),
      ordering: String(displayOrder)
    };

    let apiUrls = `${baseURL}/api/v1/product/product/${props.location.state.row.id}`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Edit !",
          "Your can not update menu. !! " + err,
          "error"
        );
      });
  };



  return (
    <>
      <Card>
        <CardHeader title={"Edit ProductManagement"}></CardHeader>
        <CardBody>


          <div className="form-inline" style={{ marginBottom: "25px" }}>

            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              Product Name
            </p>
            <input
              name="item_name"
              value={name}
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              onChange={(item_name) => setName(item_name.target.value)}
            />
          </div>
          {/* <div className="form-inline" style={{ marginBottom: "25px" }}>

            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              Code
            </p>
            <input
              name="item_name_en"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={code}
              onChange={(item_name_en) =>
                setCode(item_name_en.target.value)
              }
            />
          </div> */}

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Machine" })}:{" "}
            </p>
            <select
              as="select"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={machine_id}
              onChange={handleChangeMachine}
            >
              <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
              {listmachine &&
                listmachine.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.name}
                    </option>
                  );
                })}
            </select>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Class" })}:{" "}
            </p>
            <select
              as="select"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={class_id}
              onChange={handleChangeClass}
            >
              <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
              {listclass &&
                listclass.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.name}
                    </option>
                  );
                })}
            </select>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>

            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              is_active
            </p>
            <select name="cars" id="cars"
              value={is_active}
              onChange={(e) => {
                setIs_active(e.target.value)
              }}
            >
              <option value="1">true</option>
              <option value="0">false</option>
            </select>
          </div>

          <div className="form-inline" style={{ marginBottom: '25px' }}>
            <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
              <span style={{ color: "red" }}>
                *
              </span>
              display order
            </p>
            <input
              name="displayOrder"
              type="number"
              style={{
                height: '38px',
                width: '530px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              value={displayOrder}
              onChange={displayOrder => {
                if (displayOrder.target.value >= 0) {
                  setDisplayOrder(displayOrder.target.value)
                }
              }
              }
            />
          </div>


          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "image" })} : <br></br>
            </p>
            <div
              className="d-flex"
              style={{
                width: "530px",
              }}>
              <input
                name="item_image_path"
                style={{
                  flexGrow: "1",
                  height: "38px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                disabled
                value={item_image_path}
              />

              <span className="btn btn-primary btn-file wbt"
                style={{
                  whiteSpace: "nowrap",
                  width: "fit-content"
                }}>
                {intl.formatMessage({ id: "###", defaultMessage: "Upload/Edit" })}
                <input type="file" onChange={handleChangeItem_image_path} />
              </span>

              <button
                type="button"
                className="btn btn-danger wbt"
                onClick={removeImageItem_image_path}
              >
                {intl.formatMessage({ id: "###", defaultMessage: "delete" })}
              </button>
            </div>
          </div>

          <div
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "50%",
            }}
          >
            {stateItem_image_path.previewItem_image_path ? (
              <img
                style={{
                  width: "300px",
                  height: "300px",
                }}
                src={stateItem_image_path.previewItem_image_path}
              />
            ) : item_image_path ? (
              <img
                style={{
                  width: "300px",
                  height: "300px",
                }}
                src={item_image_path}
              />
            ) : null}
          </div>
          {stateItem_image_path.imageURLItem_image_path ? (
            <CropperImage
              image={stateItem_image_path.imageURLItem_image_path}
              handleCancel={handleCancelUploadItem_image_path}
              handleUpload={handleImageUploadItem_image_path}
              scale={1}
            />
          ) : (
            ""
          )}
          <br />
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/ProductManagement">
              <button type="button" onClick={() => localStorage.removeItem('edit')} className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "104047", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "104048", defaultMessage: "Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
